import {Box, Container, Grid} from '@chakra-ui/react'
import {useGetCartBannerQuery} from '_app/graphql/cms/generated/graphql'
import {useRouter} from '_app/hooks/useRouter'
import TopBar from '_app/components/TopBar/TopBar'
import filterBannerItems from '_app/components/TopBar/utils'
import PageSimpleHeader from '_app/components/Page/PageSimpleHeader'
import RequestEnum from '../../../enums/RequestEnum/RequestEnum'
import SeoHelper from '../../../helpers/SeoHelper/SeoHelper'
import BreakpointsHelper from 'helpers/BreakpointsHelper/BreakpointsHelper'

type Props = {
  children?: any;
  empty?: any;
};

export const CartWrapper = ({ children, empty }: Props) => {
  const { locale } = useRouter()
  const { data } = useGetCartBannerQuery({
    context: {
      clientName: RequestEnum.CMS_CONTEXT,
    },
    variables: {
      locale,
    },
  })
  const bannerItems = filterBannerItems(
    data?.cart?.data?.attributes?.cartbanner?.Items
  )

  return (
    <Box bg="main">
      <PageSimpleHeader
        topBar={
          !!bannerItems.length ? <TopBar items={bannerItems} /> : undefined
        }
        seo={{
          title: SeoHelper.getTitle(),
          description: SeoHelper.getDescription(),
        }}
      >
        <Container
          px={{
            base: 0,
          }}
          pt={{
            base: 5,
            md: 8,
          }}
          pb={{
            base: 0,
            lg: 8,
          }}
        >
          <Grid
              sx={{ display: empty ? 'flex' : 'grid', flexDirection: empty ? 'column' : 'auto' }}
            gridTemplateColumns={{ lg: '2fr 1fr' }}
            gridTemplateRows={{ lg: 'repeat(4, auto)' }}
            gridAutoFlow={{ lg: 'column' }}
            gridGap={{ base: 4, lg: 6 }}
            alignItems="flex-start"
            overflowY={{
              lg: 'visible',
            }}
            overflowX={{
              lg: 'hidden',
            }}
          >
            {children}
          </Grid>
        </Container>
      </PageSimpleHeader>
    </Box>
  )
}
